import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import View from "@modules/article/components/view";
import {defaultRoute, getProps} from "@modules/article/helpers/config";

export default new ClientModule({
	route:{ Article: <Route {...getProps(defaultRoute, View, { classNameOnPage: 'article' })} /> }
});
